<template>
    <v-card>
        <v-card-title primary-title>
            <div>
                <h3 class="headline mb-0" v-t="'user_options'"></h3>
            </div>
        </v-card-title>
        <v-card-text>
            <v-form>
                <v-layout justify-center wrap>
                    <v-flex xs12 sm6>
                        <v-checkbox
                                :disabled="disabled || loading"
                                :label="$t('white_toolbar')"
                                v-model="user.white_toolbar"
                        ></v-checkbox>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-checkbox
                                :disabled="disabled || loading"
                                :label="$t('white_navigation')"
                                v-model="user.white_navigation"
                        ></v-checkbox>
                    </v-flex>

                    <v-btn block @click="submit" :loading="loading" :disabled="disabled || loading">Speichern</v-btn>
                </v-layout>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapMutations } from 'vuex';

    export default {
        data: () => ({
            loading: false,
            user: {
                white_navigation: null,
                white_toolbar: null
            }
        }),
        props: {
            value: {
                type: Object,
                default: null
            },
            header: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value: {
                deep: true,
                handler: function () {
                    this.$set(this, 'user', _.cloneDeep(this.value));
                }
            }
        },
        mounted() {
            if (this.value) {
                this.$set(this, 'user', _.cloneDeep(this.value));
            }
        },
        methods: {
            submit() {
                if (this.loading) {
                    return;
                }

                this.loading = true;

                axios.post('/api/v1/users', this.user).then(response => {

                    if (!response.data.success) {
                        this.loading = false;
                        this.$emit('error');
                        return;
                    }

                    this.updateUser(response.data.data);

                    this.$emit('submit');

                    this.loading = false;

                }, errorResponse => {
                    console.error(errorResponse);
                    this.loading = false;
                    this.$emit('error');
                });
            },
            ...mapMutations(['updateUser'])
        }
    }
</script>
